<div class="textarea-container">
  <label>
    <textarea
      #textArea
      [maxLength]="maxlength"
      (keyup)="onKeyUp($event)"
      class="sp-textarea"
      (blur)="onBlur()"
      [class.focus]="touched"
      [value]="value"
      [disabled]="disabled"
      [rows]="rows"
    ></textarea>
    <span class="place-holder">{{ placeholder }}</span>
    <span *ngIf="maxlength && maxlength !== 524288" class="maxlength">{{ maxlength - characterCount }}</span>
    <sp-icon *ngIf="icon" class="icon icon-left" size="small" [inherit]="true" [name]="icon" type="solid"></sp-icon>
  </label>
</div>
